import React, { Component } from "react";
//import InputRange from "../../../components/Common/inputRange";
import Input from "../../components/Common/input";
//import Select from "../../../components/Common/select";

import { Col, Row } from "react-bootstrap";
class ListMappingSearch extends Component {
  state = {};
  render() {
    const {
      // handleChangeDate,
      handleChange,
      search,
      handleSubmitSearch
    } = this.props;
    return (
      <Row>
        <Col md={3}>
          <Input
            onChange={handleChange}
            value={search.name}
            name="name"
            label="Group"
          />
        </Col>
        <Col md={2} style={{ paddingTop: "25px" }}>
          <button
            className="btn btn-fill btn-success"
            onClick={handleSubmitSearch}
          >
            Search
          </button>
        </Col>
      </Row>
    );
  }
}

export default ListMappingSearch;



// WEBPACK FOOTER //
// ./src/views/item_group/listMappingSearch.jsx